<template>
  <el-container style="height: 100%">
    <el-main class="section-inner">
      <el-form inline ref="form" size="small" :model="form" label-width="80px">
        <el-form-item label>
          <el-select v-model="form.role" @change="roleChange" clearable placeholder="请选择角色">
            <el-option
              v-for="(item,i) in storeRoleData"
              :label="item.roleName"
              :value="item.id"
              :key="i"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            class="selectInput"
            style="width:250px"
            @keyup.enter.native="search"
            v-model="form.searchText"
            placeholder="输入账号/昵称/使用者/手机号"
          >
            <svg slot="suffix" class="icon" aria-hidden="true" @click="search">
              <use xlink:href="#iconsearchicon" />
            </svg>

            <!--<i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="search"></i>-->
          </el-input>
        </el-form-item>
        <el-form-item v-if="computedStatus" style="margin-top:1px;margin-bottom: 0">
          <el-dropdown id="_bp_u_batchBtn" @command="batchCommand" :split-button="true" type="primary" class="more-button">
            批量操作
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item
                v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/user/batchDeleteUser_delete')"
                command="deleteSelection"
              >批量删除</el-dropdown-item> -->
              <!-- <el-dropdown-item
                v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/user/batchUpdateUserRole_put')"
                command="showRoleDialog"
              >批量修改角色</el-dropdown-item> -->
              <el-dropdown-item
                v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/ug/batchUpdateUserGroup_put')"
                command="showGroupDialog"
              >批量修改分组</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <!-- <el-form-item>
          <el-button
            type="info"
            icon="el-icon-plus"
            v-if="this.$authUtis.hasButtonAuth('aicc-bp', '/user/addUser_post')"
            @click="addWbUser"
          >新增坐席</el-button>
        </el-form-item> -->
      </el-form>
      <el-scrollbar style="height: calc(100% - 90px)">
        <el-table tooltip-effect="light" placement="bottom" :data="storeUserData" ref="userTableRef" size="mini" :row-class-name="showCharge">
          <el-table-column align="center" type="selection" width="55" :selectable='canSelectRow'  ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="userName" label="账号"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="idNum" label="工号"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="nickname" label="坐席昵称"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" prop="realName" label="使用者"></el-table-column>
          <el-table-column align="center" width="110" prop="mobile" label="手机号"></el-table-column>
          <el-table-column align="center" width="150" prop="roleName" label="角色"></el-table-column>
          <el-table-column align="center" width="100" prop="status" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status===0">正常</span>
              <span v-if="scope.row.status===1">冻结</span>
            </template>
          </el-table-column>
          <el-table-column align="center" fixed="right" label="操作" width="150">
            <template slot-scope="scope" v-if="scope.row.id !== builtinAdminId_">
              <el-tooltip class="item" effect="light" content="查看" placement="bottom">
                <el-button
                  v-if="!$authUtis.hasButtonAuth('aicc-bp', '/user/addUser_post')"
                  @click="editUser(scope.row)"
                  type="text"
                  size="medium"
                >
                  <svg class="icon icon-bianji" aria-hidden="true">
                    <use xlink:href="#iconchakan-copy" />
                  </svg>
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="light" content="修改" placement="bottom">
                <el-button
                  v-if="$authUtis.hasButtonAuth('aicc-bp', '/user/addUser_post')"
                  @click="editUser(scope.row)"
                  type="text"
                  size="medium"
                >
                  <svg class="icon icon-bianji" aria-hidden="true">
                    <use xlink:href="#icontable-bianji" />
                  </svg>
                </el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.status===0?'锁定':'解锁'"
                placement="bottom"
                v-if="scope.row.id !== $store.state.user.loginUser.userId  && scope.row.id !== builtinAdminId_"
              >
                <el-button
                  v-if="$authUtis.hasButtonAuth('aicc-bp', '/user/lockUser_put')"
                  type="text"
                  size="medium"
                  @click="lockUser(scope.row)"
                >
                  <svg v-if="scope.row.status===0" class="icon text-danger" aria-hidden="true">
                    <use xlink:href="#icondongjie" />
                  </svg>
                  <svg v-if="scope.row.status!==0" class="icon text-success" aria-hidden="true">
                    <use xlink:href="#iconkaiqi1" />
                  </svg>
                </el-button>
              </el-tooltip>
              <!-- <el-tooltip class="item" effect="light" content="删除" placement="bottom" v-if="scope.row.id !== $store.state.user.loginUser.userId && scope.row.id !== superAdmin_">
                <el-button
                  v-if="$authUtis.hasButtonAuth('aicc-bp', '/user/deleteUser_delete')"
                  type="text"
                  size="medium"
                  @click="_deleteUser(scope.row)"
                >
                  <svg class="icon icon-delete" aria-hidden="true">
                    <use xlink:href="#icontable-delete" />
                  </svg>
                </el-button>
              </el-tooltip> -->
            </template>
          </el-table-column>
        </el-table>

        <!-- 底部分页栏 -->
        <el-row style="float:right;">
          <el-pagination
            background
            class="pageStyle"
            layout="total, prev, pager, next, jumper"
            :page-size.sync="pageSize"
            :current-page.sync="pageNum"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-row>
      </el-scrollbar>

    </el-main>
    <!-- 批量修改角色 -->
    <el-dialog
      title="批量修改角色"
      width="580px"
      :destroy-on-close="true"
      :visible.sync="dialogRoleVisible"
    >
      <div class="block-fixedwidth">
        <div class="text-danger tips-small" style="margin-bottom:20px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icontixing" />
          </svg>
          坐席角色修改后，需坐席重新登录后才会开启新的角色权限。
        </div>
        <div style="margin-bottom:20px;text-align:center">
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in storeRoleData"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="dialog-footer" style="text-align:center;margin-bottom:20px;">
          <el-button @click="cancelModRole">取 消</el-button>
          <el-button type="primary" @click="confirmModRole">确 定</el-button>
        </div>
        <div class="explain" style="font-size:12px;text-align:center">
          （如选择的角色包含某坐席组组长时，选择角色为低于该组长权限时，给与以下提示。括号中内容不在产品中显示）
          修改坐席中包含坐席组负责人，无法修改为普通客服角色。
        </div>
      </div>
    </el-dialog>
    <!-- 批量修改分组 -->
    <el-dialog
      title="批量修改分组"
      width="580px"
      :destroy-on-close="true"
      :visible.sync="dialogGroupVisible"
    >
      <div class="block-fixedwidth">
        <div class="text-danger tips-small" style="margin-bottom:20px">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#icontixing" />
          </svg>
          每个坐席只能存在于一个分组中，修改后将删除其原有分组信息。如对应坐席为组负责人，则将会取消其组负责人权限，需重新指定设置。
        </div>
        <div style="margin-bottom:20px;text-align:center">
          <TreeSelect
            class="filter-tree"
            :data="storeUserGroupData"
            :singleChange="userGroupClick"
            :selectNotLeafNode="true"
            :defaultProps="defaultProps"
            ref="tree"
          ></TreeSelect>
        </div>
        <div class="dialog-footer" style="text-align:center;margin-bottom:20px;">
          <el-button @click="cancelModGroup">取 消</el-button>
          <el-button type="primary" @click="confirmModGroup">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import TreeSelect from '@/views/auth/components/treeSelect/TreeSelect'
import {
  deleteUser,
  batchUpdateUserGroup,
  batchDeleteUser,
  batchUpdateUserRole,
  lockUser
} from '@/api/user'
import { mapActions } from 'vuex'
export default {
  name: 'Contant',
  data() {
    return {
      dialogRoleVisible: false,
      dialogGroupVisible: false,
      currentPage: 4,
      value: '',
      form: {
        role: '',
        searchText: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedUserGroupId: '',
      // 分页参数
      pageNum: 1,
      pageSize: 10,
      total: 0,
      builtinAdminId_: this.$global.defaultBuiltinAdminId,
      superAdmin_: this.$global.defaultSuperAdminId,
      checkedKeys: []// 默认选中的节点
    }
  },
  props: {
    changeViewList: Function,
    pTotal: {
      type: Number,
      default: 0
    }/* ,
    defaultLoadGroupId: String */
  },
  watch: {
    'form.role'(val) {
      this.$store.commit('user/setCurCTRoleId', { roleId: val })
    },
    'form.searchText'(val) {
      this.$store.commit('user/setCurCTSearchText', { searchText: val })
    },
    pTotal(val) {
      this.total = this.pTotal
    },
    storeUserGroupData(val) {
      if (!val || val.length === 0) {
        return
      }
      this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          this.total = res.data.total
        })
        .catch(() => {})
    }
  },
  computed: {
    storeRoleData() {
      return this.$store.state.role.rolesData
    },
    storeUserGroupData() {
      return this.$store.state.user.userGroupTree
    },
    storeUserData() {
      return this.$store.state.user.wbUserList
    },
    computedStatus() {
      return (
        this.$authUtis.hasButtonAuth('aicc-bp', '/user/batchDeleteUser_delete') &&
        this.$authUtis.hasButtonAuth('aicc-bp', '/ug/batchUpdateUserGroup_put') &&
        this.$authUtis.hasButtonAuth('aicc-bp', '/user/batchUpdateUserRole_put')
      )
    },
    storeCurGroupId() {
      return this.$store.state.user.curGroupId
    }
  },
  components: { TreeSelect },
  mounted() {
    this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
      .then(res => {
        this.total = res.data.total
      })
      .catch(() => {})
  },
  beforeDestroy() {
    this.$store.commit('user/setCurCTRoleId', { roleId: '' })
    this.$store.commit('user/setCurCTSearchText', { searchText: '' })
  },
  methods: {
    ...mapActions('user', ['_listUser']),
    canSelectRow(row, index) {
      return row.id !== this.$store.state.user.loginUser.userId && row.id !== this.superAdmin_
    },
    roleChange(val) {
      this._listUser({
        groupId: this.storeCurGroupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        paramRoleId: val,
        forceUserRole: true
      })
        .then(res => {
          this.total = res.data.total
        })
        .catch(() => {})
    },
    // 分页栏点击事件
    handleCurrentChange(val) {
      this.pageNum = val
      // this.getFileds()
      this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          this.total = res.data.total
        })
        .catch(() => {})
    },
    showCharge({ row, rowIndex }) {
      if (row.charge) {
        return 'charge'
      }
      return ''
    },
    search() {
      this.pageNum = 1
      this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
        .then(res => {
          this.total = res.data.total
        })
        .catch(() => {})
    },
    batchCommand(cmd) {
      // 判断是否有选择数据
      const selection = this.$refs.userTableRef.selection
      if (!selection || selection.length === 0) {
        this.$message.error('请勾选数据')
        return
      }
      if (cmd === 'deleteSelection') {
        this.$confirm('是否批量删除坐席？', '', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          showClose: false,
          type: 'warning'
        })
          .then(() => {
            batchDeleteUser({ rows: selection })
              .then(res => {
                if (res.code === 2000) {
                  this.$message.success(res.data)
                  this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
                    .then(res => {
                      this.total = res.data.total
                    })
                    .catch(() => {})
                } else {
                  this.$message.error(res.msg)
                }
              })
              .catch(err => {
                this.$message.error(err)
              })
          })
          .catch(() => {})
      } else if (cmd === 'showRoleDialog') {
        this.dialogRoleVisible = true
      } else if (cmd === 'showGroupDialog') {
        this.selectedUserGroupId = '' // 初始化选择数据

        this.dialogGroupVisible = true
      }
    },
    addWbUser() {
      this.$store.commit('user/setCurModUserId', { userId: '' })
      this.changeViewList(false)
    },
    editUser(row) {
      this.$store.commit('user/setCurModUserId', { userId: row.id })
      this.changeViewList(false)
    },
    lockUser(row) {
      let status = 0
      if (row.status === 0) {
        // 正常
        status = 1
      }
      lockUser({ userId: row.id, status }).then(res => {
        if (res.code === 2000) {
          this.$message.success(res.data)
          this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
            .then(res => {
              this.total = res.data.total
            })
            .catch(() => {})
        } else {
          this.$message.error(res.msg)
        }
      })
      /* .catch(err => {
          this.$message.error(err)
        }) */
    },
    _deleteUser(row) {
      this.$confirm('是否删除此坐席？', '', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        showClose: false,
        type: 'warning'
      })
        .then(() => {
          deleteUser(row.id)
            .then(res => {
              if (res.code === 2000) {
                this.$message.success(res.data)
                this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
                  .then(res => {
                    this.total = res.data.total
                  })
                  .catch(() => {})
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(err => {
              this.$message.error(err)
            })
        })
        .catch(() => {})
    },
    userGroupClick(nodeData) {
      this.selectedUserGroupId = nodeData
    },
    cancelModGroup() {
      this.dialogGroupVisible = false
      this.selectedUserGroupId = '' // 初始化选择数据
    },
    /**
     * 批量修改分组
     */
    confirmModGroup() {
      const selection = this.$refs.userTableRef.selection
      batchUpdateUserGroup({ targetId: this.selectedUserGroupId, list: selection }).then(res => {
        if (res.code === 2000) {
          this.selectedUserGroupId = ''
          this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
            .then(res => {
              this.total = res.data.total
            })
            .catch(() => {})
          this.$message.success(res.data)
          this.dialogGroupVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
      /* .catch(err => {
          this.$message.error(err)
        }) */
    },
    /**
     * 批量修改角色
     */
    cancelModRole() {
      this.value = ''
      this.dialogRoleVisible = false
    },
    /**
     * 批量修改角色
     */
    confirmModRole() {
      const selection = this.$refs.userTableRef.selection

      batchUpdateUserRole({ targetId: this.value, list: selection }).then(res => {
        if (res.code === 2000) {
          this.value = ''
          this._listUser({ groupId: this.storeCurGroupId, pageNum: this.pageNum, pageSize: this.pageSize })
            .then(res => {
              this.total = res.data.total
            })
            .catch(() => {})
          this.$message.success(res.data)
          this.dialogRoleVisible = false
        } else {
          this.$message.error(res.msg)
        }
      })
      /* .catch(err => {
          this.$message.error(err)
        }) */
    },
    handleSizeChange() {},
    handleClick() {}
  }
}
</script>
<style lang="scss" scoped>
  .el-main.section {
    overflow: hidden;
  }
textarea {
  color: inherit;
  margin: 0;
}
.el-table >>> .charge {
  background: #ecf8ff;
}
.el-select {
  width: 154px;
}
.more-button.el-dropdown {
  ::v-deep .el-dropdown__caret-button {
    max-height: 32px;
  }
}
.selectInput {
  line-height: inherit;
}
</style>
